exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nlabel[data-v-274a5825] {\n    display:block;\n    margin-left: 0!important;\n    padding: 7px 7px 7px 0 !important;\n}\n", "", {"version":3,"sources":["/home/vvikas-fedora-hp/dev/hellopeter/portal/src/pages/Notifications.vue"],"names":[],"mappings":";AACA;IACI,cAAc;IACd,yBAAyB;IACzB,kCAAkC;CACrC","file":"Notifications.vue","sourcesContent":["\nlabel[data-v-274a5825] {\n    display:block;\n    margin-left: 0!important;\n    padding: 7px 7px 7px 0 !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-274a5825","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Notifications.vue
// module id = 7O2J
// module chunks = 4